import React from "react";
import logo from "../assets/images/Logo.png";
import { FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import pasha from "../assets/images/affiliations/pasha-logo-one.jpg";
import pseb from "../assets/images/affiliations/PSEB.png";
import cxo from "../assets/images/affiliations/CXO.png";

const Footer = () => {
  return (
    <footer
      className="text-white py-8 px-4 text-left"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
      }}
    >
      <div className="container mx-auto flex flex-wrap justify-between items-start">
        {/* Social media logos Section */}
        <div className="w-full flex sapce-x-4 mb-6">
          <Link
            to="https://www.facebook.com/Scitforte"
            className="px-2 text-gray-500"
          >
            <FaFacebook className="h-5 w-5" aria-hidden="true" />
          </Link>
          <Link
            to="https://www.linkedin.com/company/scitforte/mycompany/"
            className="px-2 text-gray-500"
          >
            <FaLinkedin className="h-5 w-5" aria-hidden="true" />
          </Link>
          <Link
            to="https://www.instagram.com/scitforte?igsh=Zmp3aW5yaDQxaG05"
            className="px-2 text-gray-500"
          >
            <FaInstagram className="h-5 w-5" aria-hidden="true" />
          </Link>
        </div>

        {/* Logo and Tagline */}
        <div className="w-full md:w-auto mb-6 md:mb-0">
          <img
            src={logo}
            style={{ filter: "invert(25%)" }}
            alt="Scitforte Logo"
            className="h-10 mb-4"
          />
          <p>
            At Scitforte, we’re passionate about crafting <br /> purposeful
            software that drives meaningful impact. <br /> Join us in redefining
            what’s possible in the <br /> digital realm.
          </p>
        </div>

        {/* About Section */}
        <div className="w-full md:w-auto mb-6 md:mb-0">
          <h4 className="font-heading font-semibold text-lg mb-4">About</h4>
          <ul>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/about">About Scitforte</Link>
            </li>
          </ul>
        </div>

        {/* Services Section */}
        <div className="w-full md:w-auto mb-6 md:mb-0">
          <h4 className="font-heading font-semibold text-lg mb-4">Services</h4>
          <ul>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/itServices">IT Services</Link>
            </li>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/digitalMarketing">Digital Marketing</Link>
            </li>
          </ul>
        </div>

        {/* Products Section */}
        <div className="w-full md:w-2/12 mb-6 md:mb-0">
          <h4 className="font-heading font-semibold text-lg mb-4">Products</h4>
          <ul>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/softwareProducts/ibs">IBS</Link>
            </li>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/softwareProducts/rems">REMS</Link>
            </li>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/softwareProducts/hms">HMS</Link>
            </li>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/softwareProducts/esg">ESG</Link>
            </li>
            <li className="mb-4 hover:text-[#1E699F]">
              <Link to="/softwareProducts/erp">ERP</Link>
            </li>
          </ul>
        </div>

        {/* Contact Information and affiliation */}
        <div className="w-full md:2/5 lg:w-1/5 md:mt-10 lg:mt-0 mb-6 md:mb-0 flex flex-col md:flex-row lg:flex-col gap-8">
          <div>
            <h4 className="font-heading font-semibold text-lg mb-1 underline">Address</h4>
            <p>
              Office # 101, Building 91-C, 11th Jami Commercial Street D.H.A 7.
              P Karachi.
            </p>
            <p>
              Email:{" "}
              <Link to="mailto:info@scitforte.com" className="underline">
                info@scitforte.com
              </Link>
            </p>
            <p>Phone: +92 306 9771771</p>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-lg mb-2 underline whitespace-nowrap">
              Our Affiliates
            </h4>
            <div className="flex items-center space-x-6">
              <img src={pasha} alt="" className="h-12 w-auto object-contain" />
              <img src={pseb} alt="" className="h-12 w-auto object-contain" />
              <img src={cxo} alt="" className="h-12 w-auto object-contain" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
